import { render, staticRenderFns } from "./AssignUserToBoard.vue?vue&type=template&id=339a98e0&"
import script from "./AssignUserToBoard.vue?vue&type=script&lang=js&"
export * from "./AssignUserToBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports